import React from 'react'
import styled from 'styled-components'
import Spinner from './Utils/Spinner'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from './AuthContext'
import { withSearch } from './SearchContext'
import { shouldTranslateTo } from '../utils/utils'
import {
  Title,
  Subtitle,
  Button,
  CustomSubtitle,
  ContainerFlexColumn,
} from './Utils/CustomClasses'

const Container = styled.div`
  margin-top: -10px;

  @media screen and (max-width: 768px) and (min-width: 426px) {
    margin-top: -20px;
  }

  @media screen and (max-width: 425px) {
    margin-top: -15px;
  }
`

const PageWrapper = styled.div`
  width: -webkit-fill-available;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4vh 10% 4vh;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 4vh 5% 4vh;
  }
`

const CustomButtom = styled(Button)`
  padding: 18px 86px;
  a {
    padding: unset;
    height: auto;
  }
`

const TextWrapper = styled.div`
  max-width: 885px;
`

const ThanksForSigningUp = (props) => {
  const [pageText, setPageText] = React.useState([])
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('signup-completed', language)
  }, [])

  const handleLogin = () => {
    window.open('/auth0/login', '_self')
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <>
      {loading && <Spinner />}
      <Container>
        {/* Body */}
        <ContainerFlexColumn
          background="#FFFBF4"
          center
          gap="50px"
          gapMd="30px"
          padding="0 80px 68px 80px"
          paddingSm="0 20px 68px 20px"
        >
          <PageWrapper>
            <TextWrapper>
              <Title
                size="2.8rem"
                sizemd="2.5rem"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[0]}`,
                }}
              ></Title>
              <Subtitle
                bold
                size="1.4rem"
                sizemd="1.3rem"
                margin="50px 0 0 0"
                marginmd="40px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[1]}`,
                }}
              />
              <CustomSubtitle
                size="1.2rem"
                sizemd="1.1rem"
                margin="40px 0 0 0"
                marginmd="20px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[2]}`,
                }}
              />
            </TextWrapper>
          </PageWrapper>
          <PageWrapper>
            <CustomButtom onClick={() => handleLogin()}>
              <Link>{pageText[3]}</Link>
            </CustomButtom>
          </PageWrapper>
        </ContainerFlexColumn>
      </Container>
    </>
  )
}

export default withRouter(withSearch(withAuth(ThanksForSigningUp)))
